const letterSpacing = {
  sm: "-0.005rem",
  md: "-0.011rem",
  lg: "-0.016rem",
  xl: "-0.021rem",
  "2xl": "-0.029rem",
  "3xl": "-0.039rem",
}

module.exports = {
  letterSpacing,
}

exports.default = letterSpacing
